import axios from "axios";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { ISoftwareVersionsRepository, SoftwareVersion, SupportedSoftware, UpdateSoftwareVersionPayload } from "@domain/repositories/ISoftwareVersionsRepository";
import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class SoftwareVersionsRepository implements ISoftwareVersionsRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  async ListAsync(isEnabled?: boolean, software?: SupportedSoftware): Promise<SoftwareVersion[]> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareVersions}`;
    const parameters = {
      ...(isEnabled !== undefined && { enabled: isEnabled }),
      ...(software && { software }),
    };
    return this._requestHandlerService.handleRequestAsync<SoftwareVersion[]>(() => axios.get<SoftwareVersion[]>(url, { params: parameters }));
  }

  async UpdateAsync(version: string, payload: UpdateSoftwareVersionPayload, software: SupportedSoftware = "Spectronaut"): Promise<SoftwareVersion> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareVersionsVersion}`.replace("{version}", () => encodeURIComponent(version));
    return this._requestHandlerService.handleRequestAsync<SoftwareVersion>(() => axios.patch<SoftwareVersion>(url, payload, { params: { software } }));
  }
}
